<script>
	import {view, change_attribute, game, send_request, user} from "../client.svelte.js";
		import {exhibit_URL, image_URL} from "../core.js";
		import Input from "../elements/Input.svelte";
		import {marked} from "marked";
		import {onMount} from "svelte";

		let dialog
		let orientation = $state('landscape')   // 'landscape' | 'portrait' | 'square' - drives caption placement

		onMount( () => {
				dialog.showModal()  })

		function closing_dialog() {
				view.exhibit = null  }

		function click_outside(e) {
				if (e.target === dialog)
						dialog.close()
		}

		function show_to_players(e) {
				console.log(`EXHIBIT - show exhibit ${view.exhibit.ID} to all players`, view.exhibit)
				send_request('control', {command: "SHOW", exhibID: view.exhibit.ID})
		}

		function set_orientation(width, height) {
				if (!width || !height) return
				orientation = width === height ? 'square' : width > height ? 'landscape' : 'portrait'
		}


</script>

<!-------------------------------- HTML -------------------------------------->

<dialog bind:this={dialog} id='exhibit-dialog'
        onclose={closing_dialog} onclick={click_outside}>

	<div class="title">
		{#if game.ID && user.isMaster}
			<button class="btn-primary btn-primary-circle icon-display show-players" data-help="showplayers" onclick={show_to_players}>
				Spielern zeigen
			</button>
		{/if}
		<Input field='title' value={view.exhibit.title} disabled={game.ID} unlabeled style="font-size: x-large; font-weight: bolder; text-align: center;"
					 onchange={change_attribute.bind(view.exhibit)}/>
		<div class="close fa icon-square-xmark" onclick={() => dialog.close()}></div>
	</div>

	<div class="content" class:column={orientation === 'landscape'}>

		<div class="media">
			{#if view.exhibit.media === 'mp3'}
				<audio src={exhibit_URL(view.exhibit, true)}></audio>
			{:else if view.exhibit.media === 'mp4'}
				<video src={exhibit_URL(view.exhibit, true)} autoplay loop
						onloadedmetadata={(e) => set_orientation(e.target.videoWidth, e.target.videoHeight)}></video>
			{:else}
				<img src={exhibit_URL(view.exhibit, true)} alt=""
					 onload={(e) => set_orientation(e.target.naturalWidth, e.target.naturalHeight)} />
			{/if}
		</div>

		{#if !game.ID || view.exhibit.caption}
			<div class="side">
				<div class="caption">
					{#if game.ID}
						<p>{view.exhibit.caption}</p>
					{:else}
						<textarea id='caption' placeholder="Kurze Beschreibung des Bildes" onchange={change_attribute.bind(view.exhibit)}>{view.exhibit.caption}</textarea>
					{/if}
				</div>
			</div>
		{/if}

	</div>

</dialog>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	#exhibit-dialog
		display: flex
		flex-direction: column
		box-sizing: border-box
		max-width: calc(80vw - var(--help-width, 0))
		max-height: 100vh
		border: grey 1px solid
		background: black
		overflow: hidden

	.title
		position: relative
		flex: 0 0 auto

	.close
		position: absolute
		right: 12px
		top: 50%
		transform: translateY(-50%)
		font-size: larger
		color: lightgray
		cursor: pointer

	.close:hover
		color: lightcoral

	.show-players
		position: absolute
		left: 12px
		top: 50%
		transform: translateY(-50%)

	.content
		display: flex
		flex-direction: row
		//gap: 1em
		min-height: 0
		min-width: 0

		&.column
			flex-direction: column

	.media
		display: flex
		justify-content: center
		align-items: center
		min-height: 0
		min-width: 0

		img, video
			display: block
			max-width: 100%
			max-height: 100%
			object-fit: contain

	.side
		display: flex
		flex-direction: column
		flex: 0 1 auto
		min-height: 0
		min-width: 0
		overflow: hidden

	.content:not(.column) .side
		min-width: 260px
		max-width: 24vw

	.caption
		width: 98%
		display: flex
		flex-direction: column
		min-height: 0

	.caption p
		margin: 1em
		flex: 1 1 auto
		min-height: 0
		overflow-y: auto
		color: colors.$white
		font-family: Garamond, serif
		font-size: x-large
		font-style: normal
		font-variant: normal
		font-weight: 400
		line-height: 36px

	#caption
		margin: 12px
		width: 100%
		min-width: 240px
		box-sizing: border-box
		flex: 1 1 auto
		min-height: 0
		overflow-y: auto
</style>